// Used in web-browser console to print versions
export const logStyle = {
  header: [
    'background: #222',
    'color: white',
    'font-weight: bold',
    'font-family: monospace',
    'font-size: 12px',
    'padding: 0px 5px',
    'border-radius: 4px 4px 0 0',
    'border: 3px solid #222',
  ].join(';'),

  react: [
    'background:rgba(10, 125, 164, 0.8)',
    'color: white',
    'font-weight: bold',
    'font-size: 12px',
    'font-family: monospace',
    'padding: 3px 10px',
    'border-left: 4px solid #222',
    'border-right: 4px solid #222',
  ].join(';'),

  redux: [
    'background:rgba(88, 61, 136, 0.8)',
    'color: white',
    'font-weight: bold',
    'font-size: 12px',
    'font-family: monospace',
    'padding: 3px 10px',
    'border-left: 4px solid #222',
    'border-right: 4px solid #222',
  ].join(';'),

  mui: [
    'background:rgba(2, 116, 230, 0.8)',
    'color: white',
    'font-weight: bold',
    'font-size: 12px',
    'font-family: monospace',
    'padding: 3px 10px',
    'border-radius: 0 0 3px 3px',
    'border: 4px solid #222',
    'border-top: none',
  ].join(';'),

  reset: '',
};
